import { useTranslation } from 'react-i18next'
import {
	Pagination, PaginationContent, PaginationEllipsis,
	PaginationItem, PaginationLink, PaginationNext, PaginationPrevious,
} from '@rentflowdev/ui'

interface PanelDownProps {
	total: number
	page: number
	onPageChange: (page: number) => void
	limit: number
}

export function PanelDown({ total, page, onPageChange, limit }: PanelDownProps) {
	const { t } = useTranslation()
	const totalPages = Math.ceil(total / limit)
	if (totalPages <= 1) return null
	const pages = buildPageList(page, totalPages)

	return (
		<Pagination className="justify-end px-4 py-4">
			<PaginationContent>
				<PaginationItem>
					<PaginationPrevious
						text={t('common.prev')}
						onClick={() => onPageChange(page - 1)}
						aria-disabled={page <= 1}
						className={page <= 1 ? 'pointer-events-none opacity-50' : undefined}
					/>
				</PaginationItem>

				{pages.map((p, i) =>
					p === '...' ? (
						<PaginationItem key={`ellipsis-${i}`}>
							<PaginationEllipsis />
						</PaginationItem>
					) : (
						<PaginationItem key={p}>
							<PaginationLink
								isActive={p === page}
								onClick={() => onPageChange(p as number)}
							>
								{p}
							</PaginationLink>
						</PaginationItem>
					)
				)}

				<PaginationItem>
					<PaginationNext
						text={t('common.nextPage')}
						onClick={() => onPageChange(page + 1)}
						aria-disabled={page >= totalPages}
						className={page >= totalPages ? 'pointer-events-none opacity-50' : undefined}
					/>
				</PaginationItem>
			</PaginationContent>
		</Pagination>
	)
}

function buildPageList(current: number, total: number): (number | '...')[] {
	if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1)
	const pages: (number | '...')[] = [1]
	const start = Math.max(2, current <= 3 ? 2 : current - 1)
	const end = Math.min(total - 1, current <= 3 ? 3 : current + 1)
	if (start > 2) pages.push('...')
	for (let p = start; p <= end; p++) pages.push(p)
	if (end < total - 1) pages.push('...')
	pages.push(total)
	return pages
}
